import { RentalExpenseType } from './RentalExpenseType';

export const RentalExpenseTypeOptions = [
    {
        id: RentalExpenseType.RealEstateTaxes,
        name: 'Real Estate Taxes',
        isAnnual: true,
    },
    {
        id: RentalExpenseType.Insurance,
        name: 'Insurance',
        isAnnual: true,
    },
    {
        id: RentalExpenseType.FloodInsurance,
        name: 'Flood Insurance',
        isAnnual: true,
    },
    {
        id: RentalExpenseType.AssociationFees,
        name: 'Association Fees',
        isAnnual: true,
    },
    {
        id: RentalExpenseType.ManagementFees,
        name: 'Management Fees',
        isAnnual: false,
    },
    {
        id: RentalExpenseType.VacancyAdjustment,
        name: 'Vacancy Adjustment',
        isAnnual: false,
    },
];
